"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginAuthType = exports.DependencyType = exports.MaturityLevel = exports.LogLevel = exports.allGenerationLanguages = exports.ConsumerOperation = exports.OpenApiSpecVersion = exports.OpenApiAuthType = exports.KiotaPluginType = exports.KiotaGenerationLanguage = void 0;
exports.generationLanguageToString = generationLanguageToString;
var KiotaGenerationLanguage;
(function (KiotaGenerationLanguage) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaGenerationLanguage[KiotaGenerationLanguage["CSharp"] = 0] = "CSharp";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaGenerationLanguage[KiotaGenerationLanguage["Java"] = 1] = "Java";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaGenerationLanguage[KiotaGenerationLanguage["TypeScript"] = 2] = "TypeScript";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaGenerationLanguage[KiotaGenerationLanguage["PHP"] = 3] = "PHP";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaGenerationLanguage[KiotaGenerationLanguage["Python"] = 4] = "Python";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaGenerationLanguage[KiotaGenerationLanguage["Go"] = 5] = "Go";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaGenerationLanguage[KiotaGenerationLanguage["Ruby"] = 6] = "Ruby";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaGenerationLanguage[KiotaGenerationLanguage["Dart"] = 7] = "Dart";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaGenerationLanguage[KiotaGenerationLanguage["HTTP"] = 8] = "HTTP";
})(KiotaGenerationLanguage || (exports.KiotaGenerationLanguage = KiotaGenerationLanguage = {}));
var KiotaPluginType;
(function (KiotaPluginType) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaPluginType[KiotaPluginType["OpenAI"] = 0] = "OpenAI";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaPluginType[KiotaPluginType["ApiManifest"] = 1] = "ApiManifest";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    KiotaPluginType[KiotaPluginType["ApiPlugin"] = 2] = "ApiPlugin";
})(KiotaPluginType || (exports.KiotaPluginType = KiotaPluginType = {}));
var OpenApiAuthType;
(function (OpenApiAuthType) {
    OpenApiAuthType[OpenApiAuthType["None"] = 0] = "None";
    OpenApiAuthType[OpenApiAuthType["ApiKey"] = 1] = "ApiKey";
    OpenApiAuthType[OpenApiAuthType["Http"] = 2] = "Http";
    OpenApiAuthType[OpenApiAuthType["OAuth2"] = 3] = "OAuth2";
    OpenApiAuthType[OpenApiAuthType["OpenIdConnect"] = 4] = "OpenIdConnect";
})(OpenApiAuthType || (exports.OpenApiAuthType = OpenApiAuthType = {}));
var OpenApiSpecVersion;
(function (OpenApiSpecVersion) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    OpenApiSpecVersion[OpenApiSpecVersion["V2_0"] = 0] = "V2_0";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    OpenApiSpecVersion[OpenApiSpecVersion["V3_0"] = 1] = "V3_0";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    OpenApiSpecVersion[OpenApiSpecVersion["V3_1"] = 2] = "V3_1";
})(OpenApiSpecVersion || (exports.OpenApiSpecVersion = OpenApiSpecVersion = {}));
var ConsumerOperation;
(function (ConsumerOperation) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ConsumerOperation[ConsumerOperation["Add"] = 0] = "Add";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ConsumerOperation[ConsumerOperation["Edit"] = 1] = "Edit";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ConsumerOperation[ConsumerOperation["Remove"] = 2] = "Remove";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ConsumerOperation[ConsumerOperation["Generate"] = 3] = "Generate";
})(ConsumerOperation || (exports.ConsumerOperation = ConsumerOperation = {}));
function generationLanguageToString(language) {
    switch (language) {
        case KiotaGenerationLanguage.CSharp:
            return "CSharp";
        case KiotaGenerationLanguage.Java:
            return "Java";
        case KiotaGenerationLanguage.TypeScript:
            return "TypeScript";
        case KiotaGenerationLanguage.PHP:
            return "PHP";
        case KiotaGenerationLanguage.Python:
            return "Python";
        case KiotaGenerationLanguage.Go:
            return "Go";
        case KiotaGenerationLanguage.Ruby:
            return "Ruby";
        case KiotaGenerationLanguage.Dart:
            return "Dart";
        case KiotaGenerationLanguage.HTTP:
            return "HTTP";
        default:
            throw new Error("unknown language");
    }
}
exports.allGenerationLanguages = [
    KiotaGenerationLanguage.CSharp,
    KiotaGenerationLanguage.Go,
    KiotaGenerationLanguage.Java,
    KiotaGenerationLanguage.PHP,
    KiotaGenerationLanguage.Python,
    KiotaGenerationLanguage.Ruby,
    KiotaGenerationLanguage.TypeScript,
    KiotaGenerationLanguage.Dart,
    KiotaGenerationLanguage.HTTP,
];
/**
 * The log level from Kiota
 * @see https://learn.microsoft.com/en-us/dotnet/api/microsoft.extensions.logging.loglevel?view=dotnet-plat-ext-7.0
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["trace"] = 0] = "trace";
    LogLevel[LogLevel["debug"] = 1] = "debug";
    LogLevel[LogLevel["information"] = 2] = "information";
    LogLevel[LogLevel["warning"] = 3] = "warning";
    LogLevel[LogLevel["error"] = 4] = "error";
    LogLevel[LogLevel["critical"] = 5] = "critical";
    LogLevel[LogLevel["none"] = 6] = "none";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
var MaturityLevel;
(function (MaturityLevel) {
    MaturityLevel[MaturityLevel["experimental"] = 0] = "experimental";
    MaturityLevel[MaturityLevel["preview"] = 1] = "preview";
    MaturityLevel[MaturityLevel["stable"] = 2] = "stable";
})(MaturityLevel || (exports.MaturityLevel = MaturityLevel = {}));
var DependencyType;
(function (DependencyType) {
    DependencyType[DependencyType["abstractions"] = 0] = "abstractions";
    DependencyType[DependencyType["serialization"] = 1] = "serialization";
    DependencyType[DependencyType["authentication"] = 2] = "authentication";
    DependencyType[DependencyType["http"] = 3] = "http";
    DependencyType[DependencyType["bundle"] = 4] = "bundle";
    DependencyType[DependencyType["additional"] = 5] = "additional";
})(DependencyType || (exports.DependencyType = DependencyType = {}));
var PluginAuthType;
(function (PluginAuthType) {
    PluginAuthType["oAuthPluginVault"] = "OAuthPluginVault";
    PluginAuthType["apiKeyPluginVault"] = "ApiKeyPluginVault";
})(PluginAuthType || (exports.PluginAuthType = PluginAuthType = {}));
//# sourceMappingURL=types.js.map